import { Route } from 'react-router-dom';
import { CreateUserPage } from './create-user';
import { EditUserPage } from './edit-user';
import { ListUsersPage } from './list-users';
import { ChangePasswordPage, EditProfilePage } from './settings';
import { ViewUserPage } from './view-user';
import { RequireAuth } from '/src/components';

export { CreateUserPage, EditUserPage, ListUsersPage, ViewUserPage };

export const usersRoutes: React.ReactElement[] = [
  <Route
    path="/users/create"
    element={
      <RequireAuth>
        <CreateUserPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/users/:userId/edit"
    element={
      <RequireAuth>
        <EditUserPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/users"
    element={
      <RequireAuth>
        <ListUsersPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/users/:userId"
    element={
      <RequireAuth>
        <ViewUserPage />
      </RequireAuth>
    }
  />,

  <Route
    path="/settings/profile"
    element={
      <RequireAuth>
        <EditProfilePage />
      </RequireAuth>
    }
  />,
  <Route
    path="/settings/password"
    element={
      <RequireAuth>
        <ChangePasswordPage />
      </RequireAuth>
    }
  />,
  //   <Route path="/settings/accounts" element={<SocialAccountsPage />} />,
];
